import styled from 'styled-components';

export const SelectionCardGroupContainer = styled.fieldset`
    margin: 0;
    padding: 0;
    border: 0;
`;
